import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PagesRoutingModule } from './pages-routing.module';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';

@NgModule({
    imports: [
        SharedModule,
        PagesRoutingModule,
        NzPopconfirmModule,
        ReactiveFormsModule,
    ],
    declarations: [
    ],
    providers: []
})

export class PagesModule {}
